import "./assets/iconfont/iconfont.js";
import "./assets/iconfont/iconfont.css";
import "./assets/css/base.css";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import enus from "element-ui/lib/locale/lang/en";
import fr from "element-ui/lib/locale/lang/fr";
import de from "element-ui/lib/locale/lang/de";
import pt from "element-ui/lib/locale/lang/pt";
import it from "element-ui/lib/locale/lang/it";
import ru from "element-ui/lib/locale/lang/ru-RU";
import es from "element-ui/lib/locale/lang/es";
import zhcn from "element-ui/lib/locale/lang/zh-CN";
import ja from "element-ui/lib/locale/lang/ja";
import locale from "element-ui/lib/locale";
import VueI18n from "vue-i18n";
import echarts from "echarts";
import VueTouch from "vue-touch";
import Vue from "vue";
import "./settings";
import "./bus";
import { formatDate, paramNormal } from "./shared/filters";
import "./shared/prototypes";
import store from "./store";
import App from "./App";
import AlloyFinger from "alloyfinger";
import AlloyFingerPlugin from "alloyfinger/vue/alloy_finger_vue";
Vue.config.productionTip = false;
/* eslint-disable no-new */
Vue.prototype.$echarts = echarts;

Vue.use(AlloyFingerPlugin, {
  AlloyFinger
});
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(VueTouch, { name: "v-touch" });
Vue.component("split-h", {
  props: ["splitH"],
  template: `<div :style="\`width: 100 %; height: \${splitH}px\`">
    </div > `
});

zhcn.el.datepicker.year = "";
let langs = {
  en_US: enus,
  fr: fr,
  de: de,
  it: it,
  po: pt,
  ru: ru,
  sp: es,
  ja: ja,
  zh_CN: zhcn
};
Vue.filter("dateFormater", formatDate);
Vue.filter("paramNormal", paramNormal);
let i18n = new VueI18n({
  locale: window.settings.language || "en_US",
  messages: window.languages
});
zhcn.el.datepicker.year = "";
locale.use(langs[i18n.locale]);
new Vue({
  el: "#app",
  i18n: i18n,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js